const topologies = {
	BUCK: 'Buck',
	BOOST: 'Boost',
	FLYBACK: 'Fixed Frequency Flyback',
	QR_FLYBACK: 'Quasi Resonant Flyback',
	LDO: 'LDO',
	CHARGE_PUMP: 'Charge pump',
	INVERTING_BUCK_BOOST: 'Inverting buck boost'
};

export default topologies;
